import { usePublicDataClient } from '@juvare/platform-sdk-react/ui/hooks';
import useSwr from 'swr';
import { EnvironmentConfig } from '../../backend/types/extraTypes';

export function useEnvironmentConfig() {
    const publicDataClient = usePublicDataClient();
    return useSwr<EnvironmentConfig>(
        '/environment-config',
        async () => await publicDataClient.publicDataGetObject<EnvironmentConfig>('environment-config'),
    );
}
